
const SearchTractsBar = ({
    query,
    setQuery,
}) => {
    
    // SearchTractsBar
    return (
        
        <div className="mb-2 row">
            
            <div className="col-1"></div>
            
            <div className="col-8">
                
                <div>
                    
                    <div className="input-group input-group-lg input-group-merge">
                        <input
                            type="text"
                            style={{ height: '60px' }}
                            className="form-control form-control-prepended search "
                            placeholder="Search"
                            value={query}
                            onChange={e => setQuery(e.target.value)} />
                    </div>
                
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default SearchTractsBar
